// ─── ALL 14 PARTNERS ─────────────────────────────────────────────────────────

export const DEFAULT_PARTNERS = [
  {
    id: null,
    name: 'Well Repd Consulting',
    email: 'shane.deason@wellrepd.com',
    group_type: 'oilfield',
    email_provider: 'microsoft',
    brand_color: '#0077cc',
    secondary_color: '#005fa3',
    brand_font: 'Rajdhani',
    tagline: 'Your upstream sales partner.',
    website: 'https://wellrepd.com',
  },
  {
    name: 'Precise Downhole Solutions',
    email: 'shane@precisedhs.com',
    group_type: 'oilfield',
    email_provider: 'microsoft',
    brand_color: '#e65c00',
    secondary_color: '#b34700',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'Phoenix Oil Tools',
    email: 'sdeason@phoenixoiltools.com',
    group_type: 'oilfield',
    email_provider: 'microsoft',
    brand_color: '#c0392b',
    secondary_color: '#962d22',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'FoxSet',
    email: 'shane.d@silver-fox.net',
    group_type: 'oilfield',
    email_provider: 'microsoft',
    brand_color: '#7f6000',
    secondary_color: '#5c4600',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'CT Evolution',
    email: null,
    group_type: 'oilfield',
    email_provider: 'microsoft',
    brand_color: '#2e7d32',
    secondary_color: '#1b5e20',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'Maverick Downhole Technologies',
    email: null,
    group_type: 'oilfield',
    email_provider: 'microsoft',
    brand_color: '#6a1b9a',
    secondary_color: '#4a1570',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'Reactive Downhole Tools',
    email: null,
    group_type: 'oilfield',
    email_provider: 'microsoft',
    brand_color: '#00838f',
    secondary_color: '#006064',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'Wildcat Oil Tools',
    email: null,
    group_type: 'oilfield',
    email_provider: 'microsoft',
    email_fallback_to: 'shane.deason@wellrepd.com',
    brand_color: '#e65100',
    secondary_color: '#bf360c',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'Pipe Market™',
    email: null,
    group_type: 'oilfield',
    email_provider: 'google',
    brand_color: '#1565c0',
    secondary_color: '#0d47a1',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'GenServ Maintenance',
    email: null,
    group_type: 'entrepreneurial',
    email_provider: 'microsoft',
    brand_color: '#558b2f',
    secondary_color: '#33691e',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'Grand Slam Caps',
    email: null,
    group_type: 'entrepreneurial',
    email_provider: 'microsoft',
    brand_color: '#d32f2f',
    secondary_color: '#b71c1c',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'Travel In Faith',
    email: null,
    group_type: 'entrepreneurial',
    email_provider: 'google',
    brand_color: '#00897b',
    secondary_color: '#00695c',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'He Wins Ministry',
    email: null,
    group_type: 'volunteer',
    email_provider: 'google',
    brand_color: '#1a237e',
    secondary_color: '#0d1757',
    brand_font: null,
    tagline: null,
    website: null,
  },
  {
    name: 'KC Baseball',
    email: null,
    group_type: 'volunteer',
    email_provider: 'google',
    brand_color: '#0277bd',
    secondary_color: '#01579b',
    brand_font: null,
    tagline: null,
    website: null,
  },
];

export function applyPartnerVars(partner) {
  if (!partner) return;
  const root = document.documentElement;
  root.style.setProperty('--partner-color', partner.brand_color || '#0077cc');
  root.style.setProperty('--partner-color-secondary', partner.secondary_color || partner.brand_color || '#005fa3');
  root.style.setProperty('--partner-font', partner.brand_font || 'inherit');
}

// v1.0.6 — canonical personalization tokens used across templates, sequences, and inline compose.
// Token names MUST match the keys in `map` below. Renderer also accepts legacy HubSpot-style
// dotted tokens (e.g. "{{ contact.firstname }}") and maps them to the canonical short forms.
export const TOKEN_DEFS = [
  { token: '{{first_name}}',             label: 'First Name',         example: 'Alex' },
  { token: '{{last_name}}',              label: 'Last Name',          example: 'Reyes' },
  { token: '{{full_name}}',              label: 'Full Name',          example: 'Alex Reyes' },
  { token: '{{first_name}} {{last_name}}', label: 'First + Last',      example: 'Alex Reyes' },
  { token: '{{company}}',                label: 'Company',            example: 'Acme Oilfield' },
  { token: '{{job_title}}',              label: 'Title',              example: 'Drilling Engineer' },
  { token: '{{email}}',                  label: 'Email',              example: 'alex@acme.com' },
  { token: '{{sender_name}}',            label: 'Sender Name',        example: 'Shane Deason' },
  { token: '{{sender.first_name}}',      label: 'Sender First Name',  example: 'Shane' },
  { token: '{{partner_name}}',           label: 'Partner Name',       example: 'Well Repd' },
  { token: '{{partner_email}}',          label: 'Partner Email',      example: 'shane@wellrepd.com' },
];

// v1.7.40 (QB v18) — REAL, DEPRECATED. Zero live callers remain as of this
// version — Compose.jsx and BulkCheckInModal.jsx were migrated to the
// canonical src/lib/templateRenderer.js renderTemplate() (real, unified
// frontend Template/Merge Engine). Kept here, not deleted, in case any
// external/future code still references it; do not add new real callers.
export function substituteVars(template, context = {}) {
  if (!template) return '';
  // v1.7.39.73.03 — destructuring defaults ({ contact = {} }) only fire on
  // undefined, NOT null. A typed-in recipient with no linked contact record
  // passes primaryContact as null (Compose.jsx's useMemo finds no match and
  // returns null, not undefined), which crashed here with "Cannot read
  // properties of null (reading 'first_name')" on both the immediate Send
  // button and the new Schedule for later flow -- same root cause, same fix.
  const contact = context.contact || {};
  const partner = context.partner || {};
  const fullName = `${contact.first_name || ''} ${contact.last_name || ''}`.trim();
  const map = {
    first_name: contact.first_name || '',
    last_name: contact.last_name || '',
    full_name: fullName,
    name: fullName, // alias
    company: contact.company_name || '',
    company_name: contact.company_name || '',
    job_title: contact.job_title || contact.title || '',
    title: contact.job_title || contact.title || '', // alias
    email: contact.email || '',
    phone: contact.mobile_phone || contact.phone || contact.work_phone || '', // mobile_phone is the primary phone (#2696); contacts.phone is a fallback only
    partner_name: partner.name || '',
    partner_email: partner.email || '',
    sender_name: context.sender_name || 'Shane Deason',
    tagline: partner.tagline || '',
    website: partner.website || '',
  };

  // v1.0.6 — normalize legacy HubSpot-style tokens like {{ contact.firstname }} → {{first_name}}
  // Accepts: optional whitespace, optional "contact." / "partner." prefix, key with letters/_
  return template.replace(/\{\{\s*(?:contact\.|partner\.)?([\w]+)\s*\}\}/gi, (whole, rawKey) => {
    const key = String(rawKey).toLowerCase();
    // Common HubSpot field aliases
    const aliases = {
      firstname: 'first_name',
      lastname: 'last_name',
      fullname: 'full_name',
      companyname: 'company',
      jobtitle: 'job_title',
      emailaddress: 'email',
    };
    const norm = aliases[key] || key;
    return map[norm] != null && map[norm] !== '' ? map[norm] : map[norm] === '' ? '' : whole;
  });
}

export function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

export function formatDate(date) {
  if (!date) return '—';
  return new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatDateTime(date) {
  if (!date) return '—';
  return new Date(date).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function initials(name = '') {
  return name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2);
}

export function groupLabel(type) {
  const map = { 'Parent Company': 'Parent Company', 'Tier 1': 'Tier 1', 'Tier 2': 'Tier 2', oilfield: 'Tier 1', entrepreneurial: 'Tier 2', volunteer: 'Tier 2' };
  return map[type] || type;
}
